module.exports = __webpack_public_path__ + "static/media/ic_upi_qr_code.e3dd14f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_upi_qr_code.svg
// module id = 124
// module chunks = 0